/* Match merchandise fields, excluding incidental words in styling descriptions. */
(() => {
  const scopeQuery = (value) => {
    const plain = value.split(' AND (')[0].trim();
    const words = plain.match(/[\p{L}\p{N}]+/gu) || [];
    if (!words.length) return plain;
    return plain + words.map(word => ` AND (title:${word}* OR product_type:${word}* OR tag:${word}* OR variants.title:${word}*)`).join('');
  };
  const scopeURL = (url) => {
    const query = url.searchParams.get('q');
    if (query?.trim()) {
      url.searchParams.set('q', scopeQuery(query));
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[prefix]', 'last');
    }
    return url;
  };
  const current = new URL(location.href);
  if (/\/search\/?$/.test(current.pathname) && current.searchParams.get('q')?.trim()) {
    const scoped = scopeURL(new URL(current));
    if (current.searchParams.get('q') !== scoped.searchParams.get('q') || current.searchParams.get('type') !== 'product') {
      location.replace(scoped.href);
      return;
    }
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const url = new URL(form.action, location.href);
    if (!/\/search\/?$/.test(url.pathname)) return;
    const input = form.querySelector('[name="q"]');
    if (!input?.value.trim()) return;
    event.preventDefault();
    url.search = new URLSearchParams(new FormData(form)).toString();
    location.assign(scopeURL(url).href);
  }, true);
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link) return;
    const url = new URL(link.href, location.href);
    if (url.origin === location.origin && /\/search\/?$/.test(url.pathname) && url.searchParams.get('q')) {
      link.href = scopeURL(url).href;
    }
  });
})();
